export default __webpack_public_path__ + "static/media/mabe.6cea9182.png";